import React, { useEffect } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import { UALProvider } from "ual-reactjs-renderer";
import { Name } from "eos-common";
import {
  MindmasterLogo,
  MindmasterWrapper,
  MobileNavCont,
  Modal,
  ModalContent,
  ModalOverlay,
  NewAnchorButton,
  NewCloudButton,
  Spinner,
  SpinnerBlue,
  SpinnerGreen,
  SpinnerRed,
  WaxDAOText,
  CloseWindow,
  MobileModalOverlay,
  MindmasterMobileWrapper,
  MindmasterMobileLogo,
  WalletIconButtonWrapper,
} from "./LeftDiv";
import {
  wax,
  anchor,
  myChain,
  currentWebsiteURL,
  currentUsername,
  currentWalletProvider,
  wombat,
  APP_NAME,
} from "../data/config";
import {
  NewNavbar,
  NewUINavLinkCont,
  NewUINavLink,
  MobileNavLine,
  SidebarNavLink,
} from "../data/css/NavbarStyles";
import {
  CloseSidebarButton,
  LargeScreenNavDropDown,
  MobileSidebar,
  SidebarLinkContainer,
  SidebarLinksGap,
  SidebarOverlay,
  SidebarScrollWrapper,
} from "../data/css/SidebarStyles";
import { isLoggedIn } from "../data/functions/wallet_functions";
import { theme, ViewPoolButton } from "../Styles";
import { checkWallet, getCustomersData, logUserIn, logUserOut } from "../data/functions/global_functions";

const Navbar = () => {
  const {
    setScreenSize,
    currentUser,
    setCurrentUser,
    setWhitelistStatus,
    enterModalText,
    setEnterModalText,
    loadingDisplay,
    enterModalDisplay,
    setEnterModalDisplay,
    mobileNavDisplay,
    setMobileNavDisplay,
    setWalletSidebarIsOpen,
    currentNavbarLocation,
    mobileNavIsOpen,
    setMobileNavIsOpen,
    isLoggedInContext,
    setIsLoggedInContext,
  } = useStateContext();

  useEffect(() => {
    setMobileNavDisplay("hidden");

    if (currentUsername && isLoggedIn()) {
      setCurrentUser(currentUsername);
      setIsLoggedInContext(true);

      if (currentWalletProvider == "anchor"){
        const nameValue = new Name(currentUsername).raw().toString();
        getCustomersData(nameValue, setWhitelistStatus);
      }

    } else {
      console.log("You are not logged in");
    }
  }, []);


  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="">
      <UALProvider
        chains={[myChain]}
        authenticators={[anchor, wax, wombat]}
        appName={APP_NAME}
      >
        <ModalOverlay className={enterModalDisplay} />
        <MobileModalOverlay className={mobileNavDisplay} />
        <Modal className={enterModalDisplay}>
          <ModalContent>{enterModalText}</ModalContent>

          <Spinner style={{ display: loadingDisplay }}>
            <SpinnerRed />
            <SpinnerBlue />
            <SpinnerGreen />
          </Spinner>

          <br />
          <CloseWindow onClick={() => setEnterModalDisplay("hidden")}>
            Close Window
          </CloseWindow>
        </Modal>

        <NewNavbar>
          <MindmasterWrapper href={`${currentWebsiteURL}`}>
            <WaxDAOText>WaxDAO Names</WaxDAOText>
          </MindmasterWrapper>

          <MindmasterMobileWrapper href={`${currentWebsiteURL}`}>
          <WaxDAOText>WaxDAO Names</WaxDAOText>
            {/* <MindmasterMobileLogo src={mindmaster_logo} /> */}
          </MindmasterMobileWrapper>

          {isLoggedIn() && (
              <WalletIconButtonWrapper>
              <ViewPoolButton
                onClick={() => {
                  setWalletSidebarIsOpen(false);
                  setMobileNavIsOpen((prev) => !prev);
                }}
              >
                {currentUsername}
              </ViewPoolButton>
              </WalletIconButtonWrapper>
            )}

          {!isLoggedIn() && (
              <WalletIconButtonWrapper>
              <ViewPoolButton
                  onClick={() => {
                    setWalletSidebarIsOpen(false);
                    setMobileNavIsOpen((prev) => !prev);
                  }}
              >
                Log In
              </ViewPoolButton>
              </WalletIconButtonWrapper>
            )}

<NewUINavLinkCont
            navLocation={"Buy"}
            currentNavbarLocation={currentNavbarLocation}
          >
            <NewUINavLink href={`${currentWebsiteURL}/buy`}>
              Buy
            </NewUINavLink>
          </NewUINavLinkCont>                

          <NewUINavLinkCont
            navLocation={"Sell"}
            currentNavbarLocation={currentNavbarLocation}
          >
            <NewUINavLink href={`${currentWebsiteURL}/sell`}>
              Sell
            </NewUINavLink>
          </NewUINavLinkCont>

          <NewUINavLinkCont
            navLocation={"FAQ"}
            currentNavbarLocation={currentNavbarLocation}
          >
            <NewUINavLink href={`${currentWebsiteURL}/faq`}>
              FAQ
            </NewUINavLink>
          </NewUINavLinkCont>    

          <NewUINavLinkCont
            navLocation={"Support"}
            currentNavbarLocation={currentNavbarLocation}
          >
            <NewUINavLink href={`${currentWebsiteURL}/support`}>
            Support
            </NewUINavLink>
          </NewUINavLinkCont>                

          {/* MOBILE */}

          <MobileNavCont
            onClick={() => {
              setWalletSidebarIsOpen(false);
              setMobileNavIsOpen((prev) => !prev);
            }}
          >
            <MobileNavLine />
            <MobileNavLine />
            <MobileNavLine />
          </MobileNavCont>
        </NewNavbar>

        {/* MOBILE EXTENDED */}

        <SidebarOverlay className={!mobileNavIsOpen && "hidden"} />
        <MobileSidebar isOpen={mobileNavIsOpen}>
          <SidebarLinksGap>
            <CloseSidebarButton onClick={() => setMobileNavIsOpen(false)}>
              X
            </CloseSidebarButton>
          </SidebarLinksGap>

          <SidebarScrollWrapper>
          <SidebarLinkContainer
            navLocation={"Home"}
            currentNavbarLocation={currentNavbarLocation}
          >
           {isLoggedIn() ? (
           <span>
             <br/>
             <span className="text-sm">Hello,</span><br/>
             <a href={`${currentWebsiteURL}/listings/${currentUsername}`} style={{color: theme.secondary, fontWeight: 900}}>{currentUsername}</a>
             <br/><br/>
           </span>) : (
             <span>
               <br/>
               <span className="text-sm">Get started!</span><br/>
               <ViewPoolButton
                onClick={() => {
                  setMobileNavDisplay("hidden");
                  setEnterModalDisplay("");
                  setEnterModalText(
                    <span>
                      <NewCloudButton
                        className="ml-auto mr-auto"
                        onClick={() => logUserIn("wax", setCurrentUser, setIsLoggedInContext, setEnterModalText, setWhitelistStatus)}
                      >
                        Login With MyCloudWallet
                      </NewCloudButton>
                      <br />
                      <NewAnchorButton
                        className="ml-auto mr-auto"
                        onClick={() => logUserIn("anchor", setCurrentUser, setIsLoggedInContext, setEnterModalText, setWhitelistStatus)}
                      >
                        Login With Anchor
                      </NewAnchorButton>
                      <br />
                      <NewAnchorButton
                        className="ml-auto mr-auto"
                        onClick={() => logUserIn("wombat", setCurrentUser, setIsLoggedInContext, setEnterModalText, setWhitelistStatus)}
                      >
                        Login With Wombat
                      </NewAnchorButton>
                      <br />                      

                    </span>
                  );
                }}  
               >
                LOG IN
               </ViewPoolButton>
               <br/><br/>

             </span>
           )}
           
          </SidebarLinkContainer>
          
          <span style={{color: theme.textMain, paddingLeft: "35px", fontSize: "10px"}}>NAVIGATION</span><br/>

          <SidebarLinkContainer
            navLocation={"Buy"}
            currentNavbarLocation={currentNavbarLocation}
          >
            <SidebarNavLink href={`${currentWebsiteURL}/buy`}>
              Buy
            </SidebarNavLink>
          </SidebarLinkContainer>

          <SidebarLinkContainer
            navLocation={"Sell"}
            currentNavbarLocation={currentNavbarLocation}
          >
            <SidebarNavLink href={`${currentWebsiteURL}/sell`}>
              Sell
            </SidebarNavLink>
          </SidebarLinkContainer>

          <SidebarLinkContainer
            navLocation={"FAQ"}
            currentNavbarLocation={currentNavbarLocation}
          >
            <SidebarNavLink href={`${currentWebsiteURL}/faq`}>
              FAQ
            </SidebarNavLink>
          </SidebarLinkContainer>          

          <SidebarLinkContainer
            navLocation={"Support"}
            currentNavbarLocation={currentNavbarLocation}
          >
            <SidebarNavLink href={`${currentWebsiteURL}/support`}>
              Support
            </SidebarNavLink>
          </SidebarLinkContainer>

          {isLoggedIn() && (
            <span>
          <SidebarLinkContainer
          navLocation={"Control Panel"}
          currentNavbarLocation={currentNavbarLocation}
        >
          <SidebarNavLink href={`${currentWebsiteURL}/wallet`}>
            Control Panel
          </SidebarNavLink>
        </SidebarLinkContainer>            
            <SidebarLinkContainer>
              <br/>
            <ViewPoolButton
              onClick={() => logUserOut(currentWalletProvider, setCurrentUser, setIsLoggedInContext)}
            >
              LOG OUT
            </ViewPoolButton>
            </SidebarLinkContainer>
            </span>
          )}
          </SidebarScrollWrapper>
        </MobileSidebar>




        {/* Large Screen Dropdown On Right Side */}

        <SidebarOverlay className={!mobileNavIsOpen && "hidden"} />
        <LargeScreenNavDropDown isOpen={mobileNavIsOpen}>
          <SidebarLinksGap>
          <CloseSidebarButton onClick={() => setMobileNavIsOpen(false)}>
              X
            </CloseSidebarButton>
          </SidebarLinksGap>

          <SidebarScrollWrapper>
          <SidebarLinkContainer
            navLocation={"Home"}
            currentNavbarLocation={currentNavbarLocation}
          >
           {isLoggedIn() ? (
           <span>
             <br/>
             <span className="text-sm">Hello,</span><br/>
             <a href={`${currentWebsiteURL}/listings/${currentUsername}`} style={{color: theme.secondary, fontWeight: 900}}>{currentUsername}</a>
             <br/><br/>
              
           </span>) : (
             <span>
               <br/>
               <span className="text-sm">Get started!</span><br/>
               <ViewPoolButton
                onClick={() => {
                  setMobileNavDisplay("hidden");
                  setEnterModalDisplay("");
                  setEnterModalText(
                    <span>
                      <NewCloudButton
                        className="ml-auto mr-auto"
                        onClick={() => logUserIn("wax", setCurrentUser, setIsLoggedInContext, setEnterModalText, setWhitelistStatus)}
                      >
                        Login With MyCloudWallet
                      </NewCloudButton>
                      <br />
                      <NewAnchorButton
                        className="ml-auto mr-auto"
                        onClick={() => logUserIn("anchor", setCurrentUser, setIsLoggedInContext, setEnterModalText, setWhitelistStatus)}
                      >
                        Login With Anchor
                      </NewAnchorButton>
                      <br />
                      <NewAnchorButton
                        className="ml-auto mr-auto"
                        onClick={() => logUserIn("wombat", setCurrentUser, setIsLoggedInContext, setEnterModalText, setWhitelistStatus)}
                      >
                        Login With Wombat
                      </NewAnchorButton>
                      <br />                      

                    </span>
                  );
                }}  
               >
                LOG IN
               </ViewPoolButton>
               <br/><br/>

             </span>
           )}
           
          </SidebarLinkContainer>

        
          {isLoggedIn() && (
            <span>
              <span style={{color: theme.textMain, paddingLeft: "35px", fontSize: "10px"}}>TOOLS</span><br/>
      <SidebarLinkContainer
      navLocation={"Control Panel"}
      currentNavbarLocation={currentNavbarLocation}
    >
      <SidebarNavLink href={`${currentWebsiteURL}/wallet`}>
        Control Panel
      </SidebarNavLink>
    </SidebarLinkContainer>  

            <SidebarLinkContainer>
              <br/>
            <ViewPoolButton
              onClick={() => logUserOut(currentWalletProvider, setCurrentUser, setIsLoggedInContext)}
            >
              LOG OUT
            </ViewPoolButton>
            </SidebarLinkContainer>
            </span>
          )}
          </SidebarScrollWrapper>
        </LargeScreenNavDropDown>




      </UALProvider>
    </div>
  );
};

export default Navbar;
